import React from 'react';

import { Point2D, RenderOrder } from '@paragon/three-shared';

import { getTransformationPropsForSegment } from '../../library/utilities/updateMatrixFromSegment';
import { useMousePositionInScene } from '../hooks/useMousePositionInScene';
import { WEB_COLOR } from './WebJointSegmentVisual';

interface Props {
  readonly basePoint: Point2D;
}

export function WebSegmentPreviewVisual({ basePoint }: Props) {
  const mousePosition = useMousePositionInScene();

  return mousePosition ? (
    <mesh
      renderOrder={RenderOrder.WebSegmentVisual}
      {...getTransformationPropsForSegment({ ...basePoint, z: 0 }, mousePosition)}
    >
      <cylinderGeometry args={[0.25, 0.25, 1, 8, 1, false]} />
      <meshBasicMaterial color={WEB_COLOR} transparent depthTest={false} depthWrite={false} opacity={1} />
    </mesh>
  ) : null;
}
